import React, { useState } from 'react';
import { authFetch } from '../api';
import './FeedbackWidget.css';

function FeedbackWidget() {
  const [open, setOpen]         = useState(false);
  const [tipo, setTipo]         = useState('bug');
  const [titulo, setTitulo]     = useState('');
  const [descricao, setDescricao] = useState('');
  const [loading, setLoading]   = useState(false);
  const [sent, setSent]         = useState(false);
  const [error, setError]       = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const email = localStorage.getItem('userEmail') || 'não informado';
      const res = await authFetch('/feedback', {
        method: 'POST',
        body: JSON.stringify({ tipo, titulo, descricao, email })
      });
      if (!res.ok) throw new Error('Erro ao enviar feedback');
      setSent(true);
      setTimeout(() => {
        setSent(false);
        setOpen(false);
        setTitulo('');
        setDescricao('');
        setTipo('bug');
      }, 2500);
    } catch (e) {
      setError('Não foi possível enviar. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setError('');
    setSent(false);
  };

  return (
    <>
      {/* Botão flutuante */}
      <button className="feedback-trigger" onClick={() => setOpen(true)} title="Reportar Bug / Sugestão">
        <span className="feedback-trigger-icon">💬</span>
        <span className="feedback-trigger-label">Feedback</span>
      </button>

      {/* Modal */}
      {open && (
        <div className="feedback-overlay" onClick={handleClose}>
          <div className="feedback-modal" onClick={e => e.stopPropagation()}>
            <div className="feedback-header">
              <h2>Reportar Bug / Sugestão</h2>
              <button className="feedback-close" onClick={handleClose}>✕</button>
            </div>

            {sent ? (
              <div className="feedback-success">
                <span className="feedback-success-icon">✅</span>
                <p>Feedback enviado com sucesso!</p>
                <p className="feedback-success-sub">Obrigado pela contribuição.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                {/* Toggle Bug / Melhoria */}
                <div className="feedback-type-toggle">
                  <button
                    type="button"
                    className={`type-btn ${tipo === 'bug' ? 'active-bug' : ''}`}
                    onClick={() => setTipo('bug')}
                  >
                    🐛 Bug
                  </button>
                  <button
                    type="button"
                    className={`type-btn ${tipo === 'melhoria' ? 'active-melhoria' : ''}`}
                    onClick={() => setTipo('melhoria')}
                  >
                    💡 Melhoria
                  </button>
                </div>

                <div className="feedback-field">
                  <label>Título</label>
                  <input
                    type="text"
                    placeholder={tipo === 'bug' ? 'Ex: Erro ao carregar dashboard' : 'Ex: Adicionar filtro por data'}
                    value={titulo}
                    onChange={e => setTitulo(e.target.value)}
                    required
                    maxLength={100}
                  />
                </div>

                <div className="feedback-field">
                  <label>Descrição</label>
                  <textarea
                    placeholder={tipo === 'bug'
                      ? 'Descreva o bug: o que aconteceu, o que era esperado...'
                      : 'Descreva a melhoria que você gostaria de ver...'}
                    value={descricao}
                    onChange={e => setDescricao(e.target.value)}
                    required
                    rows={5}
                    maxLength={1000}
                  />
                  <span className="char-count">{descricao.length}/1000</span>
                </div>

                {error && <p className="feedback-error">{error}</p>}

                <div className="feedback-actions">
                  <button type="button" className="btn-cancel" onClick={handleClose}>
                    Cancelar
                  </button>
                  <button type="submit" className="btn-send" disabled={loading || !titulo || !descricao}>
                    {loading ? 'Enviando...' : '➤ Enviar'}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default FeedbackWidget;
